<script setup lang="ts">

import {SocialWidgetData} from "@/SocialWidget/types/types";
import Popup from "@/Pages/SocialWidget/Widget/Components/Popup.vue";
import MiniWidget from "@/Pages/SocialWidget/Widget/Components/MiniWidget.vue";
import SimulatorWA from "@/Pages/SocialWidget/Widget/Components/SimulatorWA.vue";
import {ref} from "vue";
import {emitStatsEvent} from "@/utils";
import PlugWidget from "@/Pages/SocialWidget/Widget/Components/PlugWidget.vue";

const props = defineProps<{
    settings: SocialWidgetData,
    widgetId: string,
    endpoint: string,
}>();
defineEmits(['close']);


const showPopup = ref(true);

function getMessengerUrl(type: string) :string {
    return `${props.endpoint}/${props.widgetId}/redirect?` + [
        `messenger=${type}`,
        `current_url=${encodeURIComponent(window.location.href)}`,
        `referer=${document.referrer}`,
        `device=${getUserDevice()}`,
        `source=sw`,
        `text=`
    ].join('&');
}

function getUserDevice():string {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }

    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }

    return "desktop";
}


function openMessenger(type: string) {
    // if(props.settings.view_settings.simulator_enabled && type === 'wa') {
    //     isOpenSimulator.value = true;
    //     showPopup.value = false;
    //     return;
    // }
    window.open(getMessengerUrl(type),'_blank');
}
// function closeSimulator() {
//     isOpenSimulator.value = false;
//     showPopup.value = true;
// }
</script>

<template>
    <div>
        <PlugWidget v-if="!settings.subscription_limits?.is_available"
                   @close="$emit('close')"/>
        <MiniWidget
            @open-t-g="openMessenger('tg'); emitStatsEvent('dg_social_click_tg', settings.stats_counters)"
            @open-w-a="openMessenger('wa'); emitStatsEvent('dg_social_click_wa', settings.stats_counters)"
            @close="$emit('close')"
            v-else-if="!settings.view_settings.popup_enabled || !settings.subscription_limits?.premium"
            v-show="showPopup"
            :settings="{
                view_settings: settings.view_settings,
                messengers_settings: settings.messengers_settings,
                copyright: settings.subscription_limits?.copyright,
            }"/>
        <Popup
            @open-t-g="openMessenger('tg'); emitStatsEvent('dg_social_click_tg', settings.stats_counters)"
            @open-w-a="openMessenger('wa'); emitStatsEvent('dg_social_click_wa', settings.stats_counters)"
            @open-phone="emitStatsEvent('dg_social_click_ph', settings.stats_counters)"
            @close="$emit('close')"
            v-show="showPopup"
            v-else-if="settings.view_settings.popup_enabled && settings.subscription_limits?.premium"
            :settings="{
                view_settings: settings.view_settings,
                messengers_settings: settings.messengers_settings,
                copyright: settings.subscription_limits?.copyright,
            }"/>
    </div>
</template>

<style scoped>

</style>
